/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Board/Board/Content/Card/Patient/Content"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let cardPatientPersonFirstNameValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'patient.person.first_name',
})
let cardPatientPersonLastNameValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'patient.person.last_name',
})
let aggregateData = fromAggregate.join(cardPatientPersonFirstNameValueData, cardPatientPersonLastNameValueData)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pr-1-Z1Yf8zk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="card.patient.person.first_name"
 data="card.patient.person.last_name"
 aggregate="/Data/aggregate join"
 text={aggregateData}
 color={dtColorsNeutral900}
 fontSize={13}
 lineHeight="20px"
 weight="medium"
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 overflowX="hidden"
 display="block"
/>
</div>
{children}
</React.Fragment>)
}